import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError, mergeMap, take } from 'rxjs/operators';
import { EventsDetailByVenue } from '@biletix/core/models/event/events-detail-by-venue.model';
import { EventService } from '@biletix/core/services/event.service';
import { GlobalErrorHandler } from '@biletix/core/services/global-error-handler.service';
import { StatusCodeResponseService } from '@biletix/core/services/status-code-response.service';
import { RouteParameter } from '@biletix/core/common/constants/route-parameter.const';
import { ApiResponseStatus } from '@biletix/core/models/api-response-status';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VenueEventListResolver implements Resolve<EventsDetailByVenue> {

  constructor(
    private eventService: EventService,
    private globalErrorHandler: GlobalErrorHandler,
    private statusCodeResponseService: StatusCodeResponseService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<EventsDetailByVenue> {
    const venueCode = route.params[RouteParameter.PARAMS.VENUE_CODE];

    return this.eventService.getAllEventsByVenueCode(venueCode).pipe(
      take(1),
      mergeMap(data => {
        if (this.isExistingVenue(data)) {
          return of(data);
        }
        this.statusCodeResponseService.setNotFound();
        return EMPTY;
      }),
      catchError(err => {
        this.globalErrorHandler.handleError(err);
        return EMPTY;
      })
    );
  }

  /**
   * Yanıtın GERÇEKTEN var olan bir mekanı tanımlayıp tanımlamadığını söyler.
   *
   * Servis, olmayan bir mekan kodu için hata üretmiyor: alanları boş bir gövde
   * dönüyor. Daha önce buradaki kontrol düz `if (data)` idi, boş gövde de truthy
   * olduğu için var olmayan mekan URL'leri 200 ile yanıtlanıyordu (yumuşak 404) —
   * arama motoruna "bu sayfa var" sinyali gidiyordu.
   *
   * Ayırt edici alan `venueId`/`venueName`: ikisi de mekanın kimliğine ait,
   * dolayısıyla mekan varsa mutlaka dolu. `performanceItems` bu kontrole DAHİL
   * EDİLMEZ; var olan bir mekanın o an satışta etkinliği olmaması meşru bir durum
   * ve 404 sayılmamalı.
   */
  private isExistingVenue(data: EventsDetailByVenue | null): boolean {
    return !!(data && (data.venueId || data.venueName));
  }
}
